var render = function render(_c, _vm) {
  return _c(
    "svg",
    {
      attrs: {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("Internet")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "------Icons",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Icons",
                transform: "translate(-174.000000, -190.000000)",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "internet",
                    transform: "translate(173.999959, 190.000000)",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      x: "0",
                      y: "0",
                      width: "16",
                      height: "16",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "Colour",
                      d: "M14.25575,11.40575 C15.4113316,9.28228466 15.4113316,6.71771534 14.25575,4.59425 L14.25575,4.59425 C13.0074463,2.30450534 10.6079096,0.879706998 8,0.879706998 C5.39209036,0.879706998 2.99255367,2.30450534 1.74425,4.59425 L1.74425,4.59425 C0.588668434,6.71771534 0.588668434,9.28228466 1.74425,11.40575 L1.74425,11.40575 C2.99255367,13.6954947 5.39209036,15.120293 8,15.120293 C10.6079096,15.120293 13.0074463,13.6954947 14.25575,11.40575 L14.25575,11.40575 Z M8,14.175 C7.33975,14.175 6.6415,13.225 6.19025,11.6955 L9.80975,11.6955 C9.3585,13.225 8.66025,14.175 8,14.175 Z M5.9575,10.7455 C5.81499168,9.99653575 5.73397166,9.23717162 5.71525,8.475 L10.28475,8.475 C10.2660283,9.23717162 10.1850083,9.99653575 10.0425,10.7455 L5.9575,10.7455 Z M2.47575,5.2545 L4.9885,5.2545 C4.85705991,6.0046379 4.78243123,6.76362744 4.76525,7.525 L1.84875,7.525 C1.90810809,6.73459368 2.12108551,5.96335727 2.47575,5.2545 L2.47575,5.2545 Z M8,1.825 C8.66025,1.825 9.3585,2.775 9.80975,4.3045 L6.19025,4.3045 C6.6415,2.775 7.33975,1.825 8,1.825 Z M10.0425,5.2545 C10.1850083,6.00346425 10.2660283,6.76282838 10.28475,7.525 L5.71525,7.525 C5.73397166,6.76282838 5.81499168,6.00346425 5.9575,5.2545 L10.0425,5.2545 Z M14.175,7.525 L11.23475,7.525 C11.2175688,6.76362744 11.1429401,6.0046379 11.0115,5.2545 L13.52425,5.2545 C13.8871553,5.96165482 14.1082231,6.73297154 14.175,7.525 Z M1.84875,8.475 L4.76525,8.475 C4.78243123,9.23637256 4.85705991,9.9953621 4.9885,10.7455 L2.47575,10.7455 C2.12108551,10.0366427 1.90810809,9.26540632 1.84875,8.475 L1.84875,8.475 Z M11.23475,8.475 L14.175,8.475 C14.1156419,9.26540632 13.9026645,10.0366427 13.548,10.7455 L11.0115,10.7455 C11.1429401,9.9953621 11.2175688,9.23637256 11.23475,8.475 Z M12.93525,4.3045 L10.79775,4.3045 C10.6204855,3.53181953 10.3171767,2.79360785 9.9,2.1195 C11.1132876,2.51657157 12.1736859,3.27992563 12.93525,4.3045 L12.93525,4.3045 Z M6.12375,2.1195 C5.69825675,2.79206704 5.3868913,3.53035627 5.20225,4.3045 L3.06475,4.3045 C3.8325506,3.27594791 4.90177891,2.51221341 6.12375,2.1195 Z M3.06475,11.6955 L5.20225,11.6955 C5.3868913,12.4696437 5.69825675,13.207933 6.12375,13.8805 C4.90177891,13.4877866 3.8325506,12.7240521 3.06475,11.6955 Z M9.9,13.8805 C10.3254932,13.207933 10.6368587,12.4696437 10.8215,11.6955 L12.959,11.6955 C12.1911994,12.7240521 11.1219711,13.4877866 9.9,13.8805 L9.9,13.8805 Z",
                      fill: "#2F477C",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }